<div [formGroup]="formGroup" class="anamnestic-data-container">
    <div *ngFor="let field of fields" class="flex-items">
        <ng-container [ngSwitch]="field.type">

            <!-- Text Input -->
            <mat-form-field [readonlyState]="isReadonly" *ngSwitchCase="1" appearance="outline" class="se-form-field">
                <mat-label>{{ field.description }}</mat-label>
                <input matInput [formControlName]="field.guid" [readonly]="isReadonly">
            </mat-form-field>

            <!-- Combo (Select) -->
            <mat-form-field [readonlyState]="isReadonly" *ngSwitchCase="2" appearance="outline" class="se-form-field">
                <mat-label>{{ field.description }}</mat-label>
                <mat-select [formControlName]="field.guid">
                    <mat-option *ngIf="isReadonly" [value]="0" selected>-</mat-option>
                    <mat-option *ngFor="let option of field.options" [value]="option.guid">
                        {{ option.description }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Label -->
            <mat-form-field [readonlyState]="isReadonly" *ngSwitchCase="3" appearance="outline" class="se-form-field">
                <mat-label>{{ field.description }}</mat-label>
                <input matInput [formControlName]="field.guid" [readonly]="isReadonly">
            </mat-form-field>

            <!-- Checkbox -->
            <mat-checkbox [readonlyState]="isReadonly" class="checkbox-custom-error" *ngSwitchCase="4" [formControlName]="field.guid">{{ field.description }}</mat-checkbox>

            <!-- Radio Buttons -->
            <div *ngSwitchCase="5" [readonlyState]="isReadonly" class="radio-data-container">
                <label>{{ field.description }}</label>
                <mat-radio-group class="mat-radio" [formControlName]="field.guid">
                    <mat-radio-button *ngFor="let option of field.options" [value]="option">
                        {{ option.description }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <!-- Numeric Text Input -->
            <mat-form-field [readonlyState]="isReadonly" *ngSwitchCase="6" appearance="outline" class="se-form-field">
                <mat-label>{{ field.description }}</mat-label>
                <input matInput type="number" [formControlName]="field.guid" [readonly]="isReadonly">
            </mat-form-field>

            <!-- Decimal Text Input -->
            <mat-form-field [readonlyState]="isReadonly" *ngSwitchCase="7" appearance="outline" class="se-form-field">
                <mat-label>{{ field.description }}</mat-label>
                <input matInput type="number" step="0.01" [formControlName]="field.guid" [readonly]="isReadonly">
            </mat-form-field>

            <!-- Money Input -->
            <mat-form-field [readonlyState]="isReadonly" *ngSwitchCase="8" appearance="outline" class="se-form-field">
                <mat-label>{{ field.description }}</mat-label>
                <input matInput type="text" [formControlName]="field.guid" [readonly]="isReadonly">
            </mat-form-field>

            <!-- Date Input -->
            <mat-form-field [readonlyState]="isReadonly" *ngSwitchCase="9" appearance="outline" class="se-form-field date-input">
                <mat-label>{{ field.description }}</mat-label>
                <input matInput
                       [placeholder]="isDateNull(field.guid) ? '-' : ''"
                       [matDatepicker]="picker"
                       [formControlName]="field.guid">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <!-- Text Area -->
            <mat-form-field [readonlyState]="isReadonly" *ngSwitchCase="10" appearance="outline" class="se-form-field">
                <mat-label>{{ field.description }}</mat-label>
                <textarea matInput [formControlName]="field.guid" [readonly]="isReadonly"></textarea>
            </mat-form-field>

            <!-- Rich Text Editor (Use any rich text editor library) -->
            <div *ngSwitchCase="11">
                <mat-form-field [readonlyState]="isReadonly" appearance="outline" class="se-form-field">
                    <mat-label>{{ field.description }}</mat-label>
                    <textarea matInput [formControlName]="field.guid" [readonly]="isReadonly"></textarea>
                </mat-form-field>
            </div>

            <!-- DateTime Input -->
            <mat-form-field [readonlyState]="isReadonly" *ngSwitchCase="12" appearance="outline" class="se-form-field date-input">
                <mat-label>{{ field.description }}</mat-label>
                <input matInput type="datetime-local" [formControlName]="field.guid">
            </mat-form-field>

            <!-- Default case to handle unknown types -->
            <p *ngSwitchDefault>Unknown Field Type</p>
        </ng-container>
    </div>
</div>


<div class="loading-overlay" *ngIf="loading">
    <mat-spinner class="center-spinner"></mat-spinner>
</div>
